import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-policy-mapping-description',
  templateUrl: './policy-mapping-description.component.html',
  styleUrls: ['./policy-mapping-description.component.scss']
})
export class PolicyMappingDescriptionComponent {
  description: string = "";
  @ViewChild('textArea', { read: ElementRef })
  textArea!: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<PolicyMappingDescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) {
      this.description = data;
    }

  onNoClick(): void {
    this.dialogRef.close();
  }
  public autoGrow() {
    const textArea = this.textArea.nativeElement;
    textArea.style.overflow = 'hidden';
    textArea.style.height = '0px';
    textArea.style.height = textArea.scrollHeight + 'px';
  }


}
